import { render } from "./GaleriaView.vue?vue&type=template&id=bd32dd0a&scoped=true"
import script from "./GaleriaView.vue?vue&type=script&lang=js"
export * from "./GaleriaView.vue?vue&type=script&lang=js"

import "./GaleriaView.vue?vue&type=style&index=0&id=bd32dd0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd32dd0a"]])

export default __exports__